import { Injectable, signal } from '@angular/core';

/**
 * Service to track authentication state and route context across the application.
 * Used by the auth interceptor to determine whether to show session expiration messages.
 * 
 * Defaults to false (public route). Only set to true by the protected route guard.
 */
@Injectable({ providedIn: 'root' })
export class AuthStateService {
    /**
     * Tracks whether the user is currently accessing a protected route.
     * A 401 on a protected route indicates session expiration.
     * A 401 on a public route is expected and doesn't warrant a session expiration message.
     * 
     * Initialized to false - only the protected route guard sets it to true.
     */
    readonly isOnProtectedRoute = signal(false);

    setOnProtectedRoute(value: boolean): void {
        this.isOnProtectedRoute.set(value);
    }
}

